export const DEFAULT_MAP_COORDS: [number, number] = [38.88, -77.0];
export const DEFAULT_ZOOM_LVL = 10;
